module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabbed-client-wallets"
  }, [_c('ActionBar', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Billing")]), _c('AddCommonCostToWallet', {
    attrs: {
      "slot": "action",
      "wallet": _vm.selectedWallet.id
    },
    slot: "action"
  })], 1), _c('div', {
    staticClass: "tabs-inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "wallets card"
  }, _vm._l((_vm.wallets), function(wallet, id) {
    return _c('div', {
      staticClass: "wallet",
      class: {
        selected: _vm.selectedIndex === id
      },
      on: {
        "click": function($event) {
          return _vm.setActive(id)
        }
      }
    }, [_c('div', {
      staticClass: "wallet-info"
    }, [_c('div', [_vm._v("W" + _vm._s(wallet.id) + " " + _vm._s(wallet.name))]), _c('div', [(wallet.payment_method !== null) ? [_c('span', [_vm._v("PM" + _vm._s(wallet.payment_method.id)), _c('small', [_vm._v(_vm._s(wallet.payment_method.name))])])] : [_c('small', [_vm._v("NO PAYMENT METHOD ASSOCIATED WITH THIS WALLET")])]], 2), _c('h3', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.wallets[id].amounts['BALANCE_VATIN'])))])]), (_vm.selectedIndex === id) ? _c('div', {
      staticClass: "wallet-actions"
    }, [(_vm.$acl('run-command-console')) ? _c('ActionButton', {
      attrs: {
        "action": _vm.billWallet,
        "button": false
      }
    }, [_c('div', {
      staticClass: "fa fa-money",
      staticStyle: {
        "color": "white"
      }
    })]) : _vm._e(), _c('div', {
      staticClass: "fa fa-pencil",
      on: {
        "click": _vm.editWallet
      }
    })], 1) : _vm._e()])
  }), 0)])]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('BackofficeMultiWallet', {
    ref: "wrList",
    model: {
      value: (_vm.selectedWallet),
      callback: function($$v) {
        _vm.selectedWallet = $$v
      },
      expression: "selectedWallet"
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [(_vm.selectedWallet) ? _c('TabbedClientInvoices', {
    ref: "inList",
    attrs: {
      "wallet": _vm.selectedWallet
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('TabbedPacketRecords')], 1), _c('div', {
    staticClass: "column"
  }, [_c('TabbedClientDeposits', {
    ref: "dpList"
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('TabbedCreditRecords', {
    ref: "crList",
    attrs: {
      "type": "Promo"
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('TabbedPaidCreditRecords', {
    ref: "crList",
    attrs: {
      "type": "Paid"
    }
  })], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9b569afa!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/ClientWallets.vue
// module id = 2645
// module chunks = 1